import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  setCnEnvironmentConfig() {
    environment.TRACEABILITY_API = environment.TRACEABILITY_API_CN;
    environment.TRACEABILITY_API_v1 = environment.TRACEABILITY_API_v1_CN;
    environment.TRACEABILITY_INTEGRATIONS_API =
      environment.TRACEABILITY_INTEGRATIONS_API_CN;
    environment.TRACEABILITY_EXTERNAL = environment.TRACEABILITY_EXTERNAL_CN;
    environment.ARP_API = environment.ARP_API_CN;
    environment.CRD_API = environment.CRD_API_CN;
  }
}
